export default {
  usuario: {
    id: null,
    nome: ""
  }
};
